module.exports = __webpack_public_path__ + "img/hr-tutorial-grid2.6425ac79.png";